import { render, staticRenderFns } from "./edit-address.component.vue?vue&type=template&id=4ae5694c&"
import script from "./edit-address.component.vue?vue&type=script&lang=ts&"
export * from "./edit-address.component.vue?vue&type=script&lang=ts&"
import style0 from "./edit-address.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit-address.component.vue"
export default component.exports